<template>
  <div>
    <PageAllow controller="DistributionShopAnalyze" action="view" />
    <Breadcrumbs :items="items" />
    <v-slide-x-transition>
      <v-sheet class="overflow-y-scroll fill-content-height">
        <v-row dense class="mx-5">
          <v-col cols="12" sm="12" md="4">
            <v-row dense align="center" class="pa-1">
              <SearcherDatetimeRangeWithRadio
                v-model="options"
                type="datetime"
                show-radios
                :radios="datetimeRadios"
                removeIcon
              />
            </v-row>
          </v-col>
          <v-col cols="12" sm="12" md="8" align-self="center">
            <v-row dense align="center" class="search-controls">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="px-0 py-0 caption font-weight-bold grey--text"
                    color="primary"
                    @click.stop="onSearch()"
                  >
                    <v-icon small class="pe-1">fa-search</v-icon>
                    {{ $t("Search.search") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.searchTip") }}</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="caption font-weight-bold grey--text"
                    @click.stop="resetSearch()"
                  >
                    <v-icon x-small class="pe-1">fa-trash-alt</v-icon>
                    {{ $t("Search.reset") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.resetTip") }}</span>
              </v-tooltip>
              <v-divider vertical />
              <v-btn
                class="caption font-weight-bold grey--text"
                :class="
                  $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                "
                small
                text
                @click.stop="$store.commit('toggleSearchPanel')"
              >
                {{ $t("Search.pro") }}
                <v-icon small class="ps-1">{{
                  $store.state.showSearchPanel ? "fa-angle-up" : "fa-angle-down"
                }}</v-icon>
              </v-btn>
              <v-btn
                v-show="distributions.length"
                class="caption font-weight-bold grey--text"
                :class="
                  $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                "
                small
                text
                @click.stop="$store.commit('toggleBarEcharts')"
              >
                {{
                  $store.state.showBarEchartsPanel
                    ? $t("App.hideSparkline")
                    : $t("App.showSparkline")
                }}
                <v-icon small class="ps-1">{{
                  $store.state.showBarEchartsPanel
                    ? "fa-angle-up"
                    : "fa-angle-down"
                }}</v-icon>
              </v-btn>
              <v-spacer />
              <!-- 导出/下载 按钮 -->
              <v-btn
                small
                color="print"
                dark
                class="ms-1"
                @click.stop="exportExcel()"
                v-if="
                  $permission.permissionAllow(
                    'DistributionShopAnalyze',
                    'detailExport'
                  )
                "
              >
                <v-icon x-small class="pe-1">fa-file-excel</v-icon>
                {{ $t("distributionShopAnalyze.Export.excel") }}
              </v-btn>
            </v-row>
          </v-col>
        </v-row>
        <v-expansion-panels
          v-model="$store.getters.panels"
          multiple
          flat
          accordion
        >
          <v-expansion-panel class="transparent-background-color">
            <v-expansion-panel-content>
              <v-row dense align="center">
                <!-- 客户 -->
                <!-- <v-col cols="12" sm="6" md="4">
                  <SearcherShops
                    v-model="shopsSelected"
                    :districtID="districtID"
                  />
                </v-col> -->
                <!-- 商品 -->
                <v-col cols="12" sm="6" md="4">
                  <SearcherMaterial v-model="materialSelected" />
                </v-col>
                <!-- 状态 -->
                <!-- <v-spacer /> -->
                <v-col cols="12" sm="6" md="4">
                  <SearcherDistributionStatus
                    :items="$consts.distribution.distribution_status"
                    v-model="options.status"
                    :label="$t('MaterialDistribution.Fields.status')"
                  />
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel
            v-show="sparklineValues.length"
            class="transparent-background-color"
          >
            <v-expansion-panel-content>
              <BarEcharts :labels="sparklineLabels" :values="sparklineValues" />
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        <!-- 表格 -->
        <div class="mx-4 mb-4">
          <v-data-table
            :headers="headers"
            :items="distributions"
            :options.sync="options"
            :loading="loading"
            :page.sync="paging.page"
            :server-items-length="paging.count"
            multi-sort
            class="elevation-1 px-4 pt-1"
            :footer-props="$t('$config.footer-props')"
          >
            <template v-slot:top>
              <v-toolbar flat class="transparent-background-color">
                <v-toolbar-title class="ms-n2 subtitle-2 font-weight-medium">
                  <span class="red--text">{{
                    $t("distributionShopAnalyze.shop_name", [shop.shop_name])
                  }}</span>
                  {{ $t("distributionShopAnalyze.distribution_detail") }}
                </v-toolbar-title>
              </v-toolbar>
              <v-divider />
            </template>
            <!-- 合计 -->
            <template v-slot:body.prepend>
              <tr class="d-none d-sm-table-row">
                <td colspan="3">
                  <span>{{ $t("TableSum") }}</span>
                </td>
                <!-- <td :align="$vuetify.rtl ? 'left' : 'right'">
                  <span>{{ order_num_total | formatTwoDot(true) }}</span>
                </td>
                <td :align="$vuetify.rtl ? 'left' : 'right'">
                  <span
                    >{{ $t("Global.money")
                    }}{{ order_price_total | formatMoney }}</span
                  >
                </td> -->
                <td :align="$vuetify.rtl ? 'left' : 'right'">
                  <span>{{ distribution_num_total | formatTwoDot(true) }}</span>
                </td>
                <td :align="$vuetify.rtl ? 'left' : 'right'">
                  <span
                    >{{ $t("Global.money")
                    }}{{ distribution_price_total | formatMoney }}</span
                  >
                </td>
              </tr>
              <!-- 小屏幕 -->
              <tr class="d-table-row d-sm-none">
                <td class="v-data-table__mobile-row">
                  <div class="v-data-table__mobile-row__header">
                    {{ $t("TableSum") }}
                  </div>
                </td>
                <td class="v-data-table__mobile-row">
                  <div class="v-data-table__mobile-row__header">
                    {{ $t("distributionShopAnalyze.order_num_total") }}
                  </div>
                  <div class="v-data-table__mobile-row__cell">
                    {{ order_num_total | formatTwoDot(true) }}
                  </div>
                </td>
                <td class="v-data-table__mobile-row">
                  <div class="v-data-table__mobile-row__header">
                    {{ $t("distributionShopAnalyze.order_price_total") }}
                  </div>
                  <div class="v-data-table__mobile-row__cell">
                    {{ $t("Global.money")
                    }}{{ order_price_total | formatMoney }}
                  </div>
                </td>
                <td class="v-data-table__mobile-row">
                  <div class="v-data-table__mobile-row__header">
                    {{ $t("distributionShopAnalyze.distribution_num_total") }}
                  </div>
                  <div class="v-data-table__mobile-row__cell">
                    {{ distribution_num_total | formatTwoDot(true) }}
                  </div>
                </td>
                <td class="v-data-table__mobile-row">
                  <div class="v-data-table__mobile-row__header">
                    {{ $t("distributionShopAnalyze.distribution_price_total") }}
                  </div>
                  <div class="v-data-table__mobile-row__cell">
                    {{ $t("Global.money")
                    }}{{ distribution_price_total | formatMoney }}
                  </div>
                </td>
              </tr>
            </template>
            <!-- 配送线路 -->
            <template v-slot:item.distribution_user_name="{ item }">
              {{
                item.distribution_user_name
                  ? item.distribution_user_name
                  : item.stock_name
              }}
            </template>
            <!-- 下单金额 -->
            <template v-slot:item.order_price_total="{ item }">
              {{ $t("Global.money") }}{{ item.order_price_total | formatMoney }}
            </template>
            <!-- 下单量 -->
            <template v-slot:item.order_num_total="{ item }">
              {{ item.order_num_total | formatTwoDot(true) }}
            </template>
            <!-- 配送时间 -->
            <template v-slot:item.distribution_time="{ item }">
              {{ item.distribution_time | formatTime }}
            </template>
            <!-- 商品配送量 -->
            <template v-slot:item.num_sum="{ item }">
              {{ item.num_sum | formatTwoDot(true) }}
            </template>
            <!-- 商品配送金额 -->
            <template v-slot:item.price_sum="{ item }">
              {{ $t("Global.money") }}{{ item.price_sum | formatMoney }}
            </template>
          </v-data-table>
        </div>
      </v-sheet>
    </v-slide-x-transition>
  </div>
</template>

<script>
import PageAllow from "@/components/PageAllow";
import i18n from "@/i18n";
import Breadcrumbs from "@/components/Breadcrumbs";
import SearcherDatetimeRangeWithRadio from "@/components/plugins/SearcherDatetimeRangeWithRadio";
import distributionShopAnalyze from "@/api/distribution_shop_analyze";
// import SearcherShops from "@/components/plugins/SearcherShops";
import SearcherDistributionStatus from "@/components/plugins/SearcherDistributionStatus";
import SearcherMaterial from "@/components/plugins/SearcherMaterial";
import BarEcharts from "@/components/plugins/BarEcharts";

const defaultOptions = {
  datetimeRadioSelected: "create",
  create_time_from:
    new Date(new Date().getTime() - 30 * 24 * 3600 * 1000)
      .toISOString()
      .substr(0, 10) + " 00:00:00",
  create_time_to: new Date().toISOString().substr(0, 10) + " 23:59:59",
  distribution_time_from: "",
  distribution_time_to: "",
  material_id: null,
  shop_ids: [],
  status: [1, 2, 3],
};

export default {
  data: () => ({
    distributions: [],
    paging: {},
    options: JSON.parse(JSON.stringify(defaultOptions)),
    loading: false,
    shopsSelected: null,
    materialSelected: null,
    shop: [],
    distribution_num_total: 0,
    distribution_price_total: 0,
    order_price_total: 0,
    order_num_total: 0,
  }),
  components: {
    Breadcrumbs,
    SearcherDatetimeRangeWithRadio,
    PageAllow,
    // SearcherShops,
    SearcherDistributionStatus,
    SearcherMaterial,
    BarEcharts,
  },

  computed: {
    items: () => [
      {
        text: i18n.t("Nav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("Nav.distributionShopAnalyze"),
        disabled: false,
        href: "/distribution-shop-analyze",
      },
      {
        text: i18n.t("Nav.distributionShopAnalyzeDetail"),
        disabled: true,
      },
    ],
    datetimeRadios: () => [
      {
        key: "create",
        text: i18n.t("distributionShopAnalyze.created_time"),
      },
      {
        key: "distribution",
        text: i18n.t("distributionShopAnalyze.distribution_time"),
      },
    ],
    headers() {
      var headers = [
        {
          text: i18n.t("distributionShopAnalyze.Fields.distributions_code"),
          align: "start",
          sortable: false,
          value: "distributions_code",
        },
        {
          text: i18n.t("distributionShopAnalyze.Fields.distribution_user_name"),
          align: "center",
          sortable: false,
          value: "distribution_user_name",
        },
        {
          text: i18n.t("distributionShopAnalyze.Fields.distribution_time"),
          align: "center",
          sortable: false,
          value: "distribution_time",
        },
        // {
        //   text: i18n.t("distributionShopAnalyze.Fields.order_num_total"),
        //   align: "end",
        //   sortable: false,
        //   value: "order_num_total",
        // },
        // {
        //   text: i18n.t("distributionShopAnalyze.Fields.order_price_total"),
        //   align: "end",
        //   sortable: false,
        //   value: "order_price_total",
        // },
        {
          text: i18n.t("distributionShopAnalyze.Fields.num_sum"),
          align: "end",
          sortable: false,
          value: "num_sum",
        },
        {
          text: i18n.t("distributionShopAnalyze.Fields.price_sum"),
          align: "end",
          sortable: false,
          value: "price_sum",
        },
      ];
      return headers;
    },
    sparklineLabels() {
      return this.distributions.map((item) => {
        return item.distribution_user_name
          ? item.distribution_user_name
          : item.stock_name;
      });
    },
    sparklineValues() {
      return this.distributions.map((item) => {
        return parseFloat(item.price_sum);
      });
    },
  },

  mounted() {
    // this.$store.commit("districtID", 0);
    this.$store.commit("searchDistrict", false);
    this.$commonUtils
      .loadOptions("distribution-shop-analyze", ["materialSelected"])
      .then(
        function (data) {
          if (data.options) {
            this.options = data.options;
          } else this.resetSearch();
          data.selecteds.forEach((selected) => {
            switch (selected.key) {
              case "materialSelected":
                this.materialSelected = selected.value;
                break;
            }
          });
        }.bind(this)
      );
    // this.getDistributionSADetailFromAPI();
  },
  methods: {
    onSearch() {
      // 搜索
      this.options = Object.assign({}, this.options);
      this.getDistributionSADetailFromAPI();
    },
    resetSearch() {
      this.alliancesSelected = [];
      this.shopsSelected = [];
      this.materialSelected = null;
      this.options = JSON.parse(JSON.stringify(defaultOptions));
    },
    getDistributionSADetailFromAPI() {
      this.loading = true;
      distributionShopAnalyze
        .fetchOne(this.$route.query.shop_id, this.options)
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              this.distributions = response.data.distributions;
              this.shop = response.data.shop;
              this.distribution_num_total =
                response.data.distribution_num_total;
              this.distribution_price_total =
                response.data.distribution_price_total;
              this.order_price_total = response.data.order_price_total;
              this.order_num_total = response.data.order_num_total;
              this.paging = response.data.paging;
            } else if (response.data.error.code.isNoResultSet()) {
              this.options.page = 1;
            }
            this.loading = false;
          }.bind(this)
        );
    },
    exportExcel() {
      distributionShopAnalyze.detailExports(
        this.$route.query.shop_id,
        this.options
      );
    },
  },
  watch: {
    options: {
      deep: true,
      handler() {
        this.getDistributionSADetailFromAPI();
      },
    },
    // 门店
    shopsSelected: {
      handler() {
        this.options.shop_ids = this.shopsSelected
          ? this.shopsSelected.map((e) => {
              return e.id;
            })
          : "";
      },
    },
    // 商品
    materialSelected: {
      handler() {
        this.options.material_id = this.materialSelected
          ? this.materialSelected.id
          : null;
      },
    },
  },
};
</script>

<style>
</style>